export default __webpack_public_path__ + "static/media/Slider6.f94d83ca.jpg";